import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  type: null,
  title: "",
  data: null,
  refreshData: 0,
};

const productModalSlice = createSlice({
  name: "productModal",
  initialState,
  reducers: {
    openProductModal: (state, action) => {
      state.isOpen = true;
      state.type = action.payload.type;
      state.title = action.payload.title;
      state.data = action.payload.data;
      state.refreshData = action.payload.refreshData;
    },

    closeProductModal: (state) => {
      state.isOpen = false;
      state.type = null;
      state.title = "";
      state.data = null;
    },

    refreshProductList: (state) => {
      state.refreshData = Date.now();
    },
  },
});

export const {
  openProductModal,
  closeProductModal,
  refreshProductList,
} = productModalSlice.actions;

export default productModalSlice.reducer;